const features = [
  {
    icon: 'ri-store-2-line',
    title: '店舗設置型QRコード',
    desc: 'レジ横・入口・メニュー表など任意の場所にQRコードを設置。来店客が自然にスキャンする動線を作ります。',
  },
  {
    icon: 'ri-link-m',
    title: '自動トラッキング',
    desc: 'スキャンと同時にアフィリエイトリンクが紐付き、成果を自動計測。面倒な設定は一切不要です。',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'リアルタイム分析',
    desc: '管理画面でスキャン数・クリック数・成果報酬をリアルタイムに確認。データドリブンな改善が可能。',
  },
  {
    icon: 'ri-wallet-3-line',
    title: '成果報酬型',
    desc: '実際の成果（購入・会員登録など）が発生したときのみ報酬が生まれる安心の課金モデル。',
  },
  {
    icon: 'ri-team-line',
    title: 'アフィリエイター紹介',
    desc: '国内最大級のアフィリエイターネットワークと連携。店舗に最適なパートナーをマッチングします。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '専任サポート',
    desc: '導入から運用まで専任スタッフがサポート。技術的な知識がなくても安心してご利用いただけます。',
  },
];

export default function ServiceOverview() {
  return (
    <section id="service" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-red-500 text-sm font-bold tracking-widest uppercase">Service</span>
          <h2 className="text-4xl font-black text-gray-900 mt-3 mb-4">サービス概要</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            STORADは、店舗QRコードとアフィリエイトを融合した<strong>まったく新しいO2Oマーケティングサービス</strong>です。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="group bg-gray-50 rounded-lg p-7 hover:bg-red-50 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-red-100 group-hover:bg-red-200 rounded-lg mb-5 transition-colors">
                <i className={`${f.icon} text-red-500 text-xl`}></i>
              </div>
              <h3 className="text-gray-900 font-bold text-base mb-2">{f.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-red-500 to-red-600 rounded-xl p-10 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1">
            <h3 className="text-white text-2xl font-black mb-3">まずは無料デモをお試しください</h3>
            <p className="text-red-100 text-sm leading-relaxed">
              実際のQRコードを使ったデモ環境をご用意。導入前に効果をご体験いただけます。
            </p>
          </div>
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="cursor-pointer whitespace-nowrap bg-white text-red-500 font-bold px-8 py-4 rounded-md text-sm hover:bg-red-50 transition-colors"
          >
            無料デモを申し込む →
          </button>
        </div>
      </div>
    </section>
  );
}
